<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12 p-0">
      <div class="login-card">
        <div>
          <!-- Logo Section - Outside the white card -->
          <div>
            <a class="logo text-center">
              <h2 class="text-primary mb-0">Municipal Services</h2>
            </a>
          </div>

          <!-- White Card - login-main -->
          <div class="login-main">
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="theme-form">
              <h2 class="text-center">Sign in to account</h2>
              <p class="text-center">Enter your email & password to login</p>

              <!-- Error Message -->
              <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
                <i class="fa fa-exclamation-triangle"></i>
                {{ errorMessage }}
              </div>

              <!-- Email Field -->
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input
                  type="email"
                  id="email"
                  formControlName="email"
                  class="form-control"
                  [class.is-invalid]="f['email'].invalid && f['email'].touched"
                  placeholder="Test@gmail.com"
                  autocomplete="email"
                />
                <div *ngIf="f['email'].invalid && f['email'].touched" class="invalid-feedback d-block">
                  <div *ngIf="f['email'].errors?.['required']">Email is required</div>
                  <div *ngIf="f['email'].errors?.['email']">Please enter a valid email address</div>
                </div>
              </div>

              <!-- Password Field -->
              <div class="form-group">
                <label class="col-form-label">Password</label>
                <div class="form-input position-relative">
                  <input
                    [type]="showPassword ? 'text' : 'password'"
                    id="password"
                    formControlName="password"
                    class="form-control"
                    [class.is-invalid]="f['password'].invalid && f['password'].touched"
                    placeholder="*********"
                    autocomplete="current-password"
                  />
                  <div class="show-hide">
                    <span [class.show]="!showPassword" (click)="togglePasswordVisibility()"></span>
                  </div>
                </div>
                <div *ngIf="f['password'].invalid && f['password'].touched" class="invalid-feedback d-block">
                  <div *ngIf="f['password'].errors?.['required']">Password is required</div>
                  <div *ngIf="f['password'].errors?.['minlength']">Password must be at least 6 characters</div>
                </div>
              </div>

              <!-- Remember Password & Forgot Password -->
              <div class="form-group mb-0">
                <div class="checkbox p-0">
                  <input id="checkbox1" type="checkbox" formControlName="rememberMe"/>
                  <label class="text-muted" for="checkbox1">Remember password</label>
                </div>
                <a class="link" href="javascript:void(0)">Forgot password?</a>

                <!-- Submit Button -->
                <div class="text-end mt-3">
                  <button
                    type="submit"
                    class="btn btn-primary btn-block w-100"
                    [disabled]="loading"
                  >
                    <span *ngIf="!loading">Sign in</span>
                    <span *ngIf="loading">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Signing in...
                    </span>
                  </button>
                </div>
              </div>

              <!-- Social Login Section -->
              <div class="login-social-title">
                <h6>Or Sign in with</h6>
              </div>
              <div class="form-group">
                <ul class="login-social">
                  <li><a href="javascript:void(0)"><i class="icon-facebook"></i></a></li>
                  <li><a href="javascript:void(0)"><i class="icon-linkedin"></i></a></li>
                  <li><a href="javascript:void(0)"><i class="icon-twitter"></i></a></li>
                  <li><a href="javascript:void(0)"><i class="icon-instagram"></i></a></li>
                </ul>
              </div>

              <!-- Create Account Link -->
              <p class="mt-4 mb-0 text-center">
                <span class="text-muted">Don't have account?</span>
                <a class="ms-2" href="javascript:void(0)">Create Account</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
